import React, { useCallback, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Loader from "Common/Loader";
import {
  GetOldGoldRateByKaratIdApi,
  GetKaratSelectList,
  GetStyleList,
  GetCollectionList,
  GetCategroyList,
  GetDimondClarityList,
  GetMrpTypeList,
  GetMaterialTypeList,
  checkProductAvailble,
} from "../../services";
import { AddProductFormModel } from "../models/custom-order-form-model";
import { v4 as uuidv4 } from 'uuid';
import notistack from "modules/core/notistack";
import { log } from "console";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import { apiClient } from "helpers/api_helper";
import { HttpStatus } from "modules/core";
import RedirectionModal from "./RedirectionModal";

interface AddProductModalProps {
  show: boolean;
  onHide: () => void;
  reloadDataSource?: () => void;
  onProductListChange?: (product: AddProductFormModel, isEdit: boolean) => void;
  editProduct?: AddProductFormModel | null;
  setKaratListFor24: any;
}

const CustomOrderModal: React.FC<AddProductModalProps> = ({
  show,
  onHide,
  onProductListChange,
  editProduct,
  setKaratListFor24,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedMaterialType, setSelectedMaterialType] = useState("");
  const [karatList, setKaratList] = useState<{ value: string; text: string }[]>([]);
  const [styleList, setStyleList] = useState<{ value: string; text: string }[]>([]);
  const [collectionList, setCollectionList] = useState<{ value: string; text: string }[]>([]);
  const [categoryList, setCategoryList] = useState<{ value: string; text: string }[]>([]);
  const [dimondClarityList, setDimondClarityList] = useState<{ value: string; text: string }[]>([]);
  const [mrpTypeList, setMrpTypeList] = useState<{ value: string; text: string }[]>([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedKtId, setSelectedKtId] = useState<any>();
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<AddProductFormModel>({
    defaultValues: {
      srpMrp: "MRP"
    }
  });

  const fromNetWt = watch("fromNetWt");
  const toNetWt = watch("toNetWt");
  const goldRate = watch("goldRate");
  const colorStoneAmt = watch("colorStoneAmt");
  const diamondAmount = watch("diaAmt");

  useEffect(() => {
    const fwt = Number(fromNetWt);
    const twt = Number(toNetWt);
    const goldRt = Number(goldRate);
    const colorStone = Number(colorStoneAmt);
    const diamond = Number(diamondAmount);

    const isValid = (val: number) => !isNaN(val) && val > 0;

    const shouldCalculate =
      isValid(fwt) || isValid(twt) || isValid(colorStone) || isValid(diamond);

    if (!shouldCalculate || !isValid(goldRt)) {
      setValue("subMrp", 0);
      return;
    }

    let avgWt = 0;
    if (isValid(fwt) && isValid(twt)) {
      avgWt = (fwt + twt) / 2;
    } else if (isValid(fwt)) {
      avgWt = fwt;
    } else if (isValid(twt)) {
      avgWt = twt;
    }

    const subMRP = (avgWt * goldRt) + (isValid(colorStone) ? colorStone : 0) + (isValid(diamond) ? diamond : 0);

    setValue("subMrp", parseFloat(subMRP.toFixed(2)));
  }, [fromNetWt, toNetWt, goldRate, colorStoneAmt, diamondAmount, setValue]);


  useEffect(() => {
    if (!show || selectedMaterialType !== "Gold") return;

    const fetchGoldDropdowns = async () => {
      try {
        // const [karats, styles, collections, categories] = await Promise.all([
        //   GetKaratSelectList(),
        //   GetStyleList(),
        //   GetCollectionList(),
        //   GetCategroyList(),
        // ]);
        const [karats, estimateSelectList] = await Promise.all([
          GetKaratSelectList(),
          apiClient.get('api/v1/EstimatePayment/GetEstimateSelectList'),
        ]);

        // Destructure the response
        const { category, style, collection } = estimateSelectList.data || {};

        setKaratList(karats);
        setKaratListFor24(karats)
        setStyleList(style || []);
        setCollectionList(collection || []);
        setCategoryList(category || []);

        if (editProduct && karats.length > 0) {
          setValue("styleNoText", getTextFromList(editProduct.styleNo || '', style || []));
          setValue("categoryText", getTextFromList(editProduct.category || '', category || []));
          setValue("collectionNameText", getTextFromList(editProduct.collectionName || '', collection || []));
          setValue("ktText", getTextFromList(editProduct.kt || '', karats));
          setSelectedKtId(editProduct.kt?.toString())
          GetOldGoldRateByKaratId(editProduct?.kt?.toString());
          if (editProduct?.image)
            setImagePreview(editProduct?.image);
          // if (editProduct.kt?.toString()) {
          //   GetOldGoldRateByKaratId(editProduct.kt?.toString());
          // }
        }
      } catch (err) {
        console.error("Error fetching gold dropdowns:", err);
        toast.error("Failed to load dropdowns");
      }
    };

    fetchGoldDropdowns();
  }, [show, selectedMaterialType, editProduct]);

  useEffect(() => {
    if (!show || selectedMaterialType !== "Diamond") return;

    const fetchDiamondDropdowns = async () => {
      try {
        // const [karats, styles, collections, categories, clarity, mrpType] = await Promise.all([
        //   GetKaratSelectList(),
        //   GetStyleList(),
        //   GetCollectionList(),
        //   GetCategroyList(),
        //   GetDimondClarityList(),
        //   GetMrpTypeList(),
        // ]);

        const [karats, estimateSelectList, clarity, mrpType] = await Promise.all([
          GetKaratSelectList(),
          apiClient.get('api/v1/EstimatePayment/GetEstimateSelectList'),
          GetDimondClarityList(),
          GetMrpTypeList(),
        ]);

        // Destructure the response
        const { category, style, collection } = estimateSelectList.data || {};

        // console.log(category, style, collection)
        setKaratList(karats || []);
        setStyleList(style || []);
        setCollectionList(collection || []);
        setCategoryList(category || []);
        setDimondClarityList(clarity || []);
        setMrpTypeList(mrpType || []);

        // Set default MRP for new products only
        if (!editProduct) {
          const mrpItem = mrpType.find((item: any) => item.text === "MRP");
          if (mrpItem) {
            setValue("srpMrp", mrpItem.value);
            setValue("srpMrpText", 'MRP');
          }
        }

        // Set text values for edit mode after dropdowns are loaded
        if (editProduct) {
          setValue("styleNoText", getTextFromList(editProduct.styleNo || '', style || []));
          setValue("categoryText", getTextFromList(editProduct.category || '', category || []));
          setValue("collectionNameText", getTextFromList(editProduct.collectionName || '', collection || []));
          setValue("odKtText", getTextFromList(editProduct.odKt || '', karats || []));
          setValue("diamondClarityText", getTextFromList(editProduct.diamondClarity || '', clarity || []));
          setValue("srpMrpText", getTextFromList(editProduct.srpMrp || '', mrpType || []));
          if (editProduct?.image)
            setImagePreview(editProduct?.image);
          // Also set the gold rate if odKt exists
          if (editProduct.odKt) {
            GetOldGoldRateByKaratId(editProduct.odKt);
          }
        }
      } catch (err) {
        console.error("Error fetching diamond dropdowns:", err);
        toast.error("Failed to load dropdowns");
      }
    };

    fetchDiamondDropdowns();
  }, [show, selectedMaterialType, editProduct, setValue]);


  useEffect(() => {
    if (show && editProduct) {
      reset(editProduct);
      setSelectedMaterialType(editProduct.materialType || "");
      setIsEditMode(true);
    } else if (show && !editProduct) {
      reset({
        srpMrp: "MRP"
      });
      setSelectedMaterialType("");
      setIsEditMode(false);
    }
  }, [editProduct, show, reset]);

  useEffect(() => {
    const fwt = Number(fromNetWt);
    const twt = Number(toNetWt);
    const rate = Number(goldRate);

    const isValidNumber = (val: number) => !isNaN(val) && val > 0;

    const validFwt = isValidNumber(fwt) ? fwt : null;
    const validTwt = isValidNumber(twt) ? twt : null;

    let avgWt = 0;

    if (validFwt !== null && validTwt !== null) {
      avgWt = (validFwt + validTwt) / 2;
    } else if (validFwt !== null) {
      avgWt = validFwt;
    } else if (validTwt !== null) {
      avgWt = validTwt;
    }

    if (isValidNumber(rate) && avgWt > 0) {
      const est = avgWt * rate;
      setValue("estimateAmt", parseFloat(est.toFixed(2)));
    } else {
      setValue("estimateAmt", 0);
    }
  }, [fromNetWt, toNetWt, goldRate, setValue]);


  const GetOldGoldRateByKaratId = async (ktValue: any) => {
    try {
      if (!ktValue) return
      const response = await GetOldGoldRateByKaratIdApi(ktValue);
      setValue("goldRate", response?.metalRate);
    } catch (err) {
      console.error("Error fetching gold rate:", err);
      notistack.error("Failed to fetch gold rate");
      setValue("goldRate", 0);
    }
  };




  const handleFileChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      toast.warning("Only JPG, JPEG, and PNG files are allowed.");
      e.target.value = "";
      return;
    }
    // Check file size (1MB limit)
    const maxSize = 1 * 1024 * 1024; // 1MB in bytes
    if (file.size > maxSize) {
      toast.error("Image size must be less than 1MB");
      e.target.value = ""; // Clear the file input
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      setValue("image", result);
      setImagePreview(result);
    };
    reader.readAsDataURL(file);
  }, [setValue]);

  // Image handling functions
  const handleRemoveImage = useCallback(() => {
    setImagePreview(null);
    setValue("image", "");
  }, [setValue]);



  const onSubmitGold = async (data: AddProductFormModel) => {
    setLoading(true);

    try {
      // if (!data.goldRate || !data.kt) {
      //   toast.error("Please fill all required gold fields");
      //   setLoading(false);
      //   return;
      // }

      const goldProduct = new AddProductFormModel();
      goldProduct.id = isEditMode ? editProduct?.id! : uuidv4();
      goldProduct.materialType = selectedMaterialType;

      // Store both value and text for each dropdown field
      goldProduct.styleNo = data.styleNo || '';
      goldProduct.styleNoText = data.styleNoText || '';
      goldProduct.category = data.category || '';
      goldProduct.categoryText = data.categoryText || '';
      goldProduct.collectionName = data.collectionName || '';
      goldProduct.collectionNameText = data.collectionNameText || '';
      goldProduct.kt = data.kt || '';
      goldProduct.ktText = data.ktText || '';

      goldProduct.fromNetWt = data.fromNetWt || 0;
      goldProduct.toNetWt = data.toNetWt || 0;
      goldProduct.goldRate = data.goldRate || 0;
      goldProduct.estimateAmt = data.estimateAmt || 0;
      goldProduct.image = data.image;
      goldProduct.size = Number(data?.size || 0);

      if (onProductListChange) {
        onProductListChange(goldProduct, isEditMode);
      }

      toast.success(isEditMode ? "Gold product updated successfully" : "Gold product saved successfully");
      handleModalHide();
    } catch (err) {
      console.error("Error saving gold product:", err);
      toast.error("Failed to save gold product");
    } finally {
      setLoading(false);
    }
  };

  const onSubmitDiamond = async (data: AddProductFormModel) => {
    setLoading(true);

    try {
      const diamondProduct = new AddProductFormModel();
      diamondProduct.id = isEditMode ? editProduct?.id! : uuidv4();
      diamondProduct.materialType = selectedMaterialType;

      // Store both value and text for each dropdown field
      diamondProduct.styleNo = data.styleNo || '';
      diamondProduct.styleNoText = data.styleNoText || '';
      diamondProduct.category = data.category || '';
      diamondProduct.categoryText = data.categoryText || '';
      diamondProduct.collectionName = data.collectionName || '';
      diamondProduct.collectionNameText = data.collectionNameText || '';
      diamondProduct.odKt = data.odKt || '';
      diamondProduct.odKtText = data.odKtText || '';
      diamondProduct.ktText = data.kt || '';
      diamondProduct.diamondClarity = data.diamondClarity || '';
      diamondProduct.diamondClarityText = data.diamondClarityText || '';
      diamondProduct.srpMrp = data.srpMrp || '';
      diamondProduct.srpMrpText = data.srpMrpText || '';

      // Other fields remain the same
      diamondProduct.colorCode = data.colorCode || '';
      diamondProduct.kt = data.kt || '';
      diamondProduct.diaWt = data.diaWt || 0;
      diamondProduct.diaQty = data.diaQty || 0;
      diamondProduct.premiumPromo = data.premiumPromo || '';
      diamondProduct.diaAmt = data.diaAmt || 0;
      diamondProduct.colorStoneAmt = data.colorStoneAmt || 0;
      diamondProduct.goldRate = data.goldRate;
      diamondProduct.fromNetWt = data.fromNetWt || 0;
      diamondProduct.toNetWt = data.toNetWt || 0;
      diamondProduct.subMrp = data.subMrp || 0;
      diamondProduct.cgst = data.cgst || 0;
      diamondProduct.igst = data.igst || 0;
      diamondProduct.mrp = data.mrp || 0;
      diamondProduct.image = data.image;
      diamondProduct.size = Number(data?.size || 0);

      if (onProductListChange) {
        onProductListChange(diamondProduct, isEditMode);
      }

      toast.success(isEditMode ? "Diamond product updated successfully" : "Diamond product saved successfully");
      handleModalHide();
    } catch (err) {
      console.error("Error saving diamond product:", err);
      toast.error("Failed to save diamond product");
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data: AddProductFormModel) => {
    if (selectedMaterialType === 'Gold') {
      setStyleNumber('')
      setKarat('')
      await onSubmitGold(data);
    } else if (selectedMaterialType === 'Diamond') {
      setStyleNumber('')
      setKarat('')
      await onSubmitDiamond(data);
    } else {
      toast.error("Please select a material type");
    }
  };

  const [styleNumber, setStyleNumber] = useState<string | null>(null)
  const [karat, setKarat] = useState<string | null>(null)
  const [isRedirectOpen, setIsRedirectOpen] = useState(false)
  const [productAvailbleData, setProductAvailbleData] = useState<any | null>(null)

  const getAvailableProductDetails = async () => {
    if (!(styleNumber?.trim() && karat?.trim())) return
    try {
      const payload = {
        styleNo: styleNumber,
        ktId: karat
      }
      const response: any = await checkProductAvailble(payload)
      if (response?.status == HttpStatus.Success && Array.isArray(response.data) && response?.data?.length > 0) {
        setProductAvailbleData(response)
        setIsRedirectOpen(true)
      } else {
        setIsRedirectOpen(false)
        setProductAvailbleData(null)
      }
    } catch (error: any) {
      console.log(error)
      setIsRedirectOpen(false)
      setProductAvailbleData(null)
      notistack.error(error)
    }
  }

  useEffect(() => {
    if (!(styleNumber?.trim() && karat?.trim())) return
    getAvailableProductDetails()
  }, [styleNumber, karat])

  const handleMaterialTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedMaterialType(value);
    setValue("materialType", value);
    clearErrors()
    if (value && !isEditMode) {
      if (value === "Diamond") {
        // reset({
        //   materialType: value,
        //   srpMrp: "MRP"
        // });
        // setValue("srpMrp", "MRP");
        setValue("materialType", value);
      } else {
        reset({
          materialType: value
        });
      }
    }
  };

  const handleModalHide = () => {
    reset();
    setStyleNumber('')
    setKarat('')
    reset({
      srpMrp: "MRP" // Keep default for new products
    });
    setValue('image', '')
    setImagePreview('')
    setSelectedMaterialType("");
    setSelectedKtId("");
    setIsEditMode(false);
    onHide();
  };

  const fromNetWtToValidate = watch("fromNetWt");
  const toNetWtToValidate = watch("toNetWt");

  const odKt = watch("odKt");
  const colorCode = watch("colorCode");

  useEffect(() => {
    const selectedKt = karatList.find(kt => kt.value === odKt);
    GetOldGoldRateByKaratId(selectedKt?.value as string)
    if (odKt && colorCode) {
      const ktText = selectedKt ? selectedKt.text : odKt;
      setValue("kt", `${ktText} - ${colorCode}`);
    } else if (odKt && !colorCode) {
      const selectedKt = karatList.find(kt => kt.value === odKt);
      const ktText = selectedKt ? selectedKt.text : odKt;
      setValue("kt", ktText);
    } else if (!odKt && colorCode) {
      setValue("kt", colorCode);
    } else {
      setValue("kt", "");
    }
  }, [odKt, colorCode, setValue]);

  // useEffect(() => {
  //   if (fromNetWtToValidate && toNetWtToValidate && fromNetWtToValidate >= toNetWtToValidate) {
  //     setValue("fromNetWt", undefined);
  //   }
  // }, [fromNetWtToValidate, toNetWtToValidate, setValue]);

  useEffect(() => {
    const from = parseFloat(fromNetWtToValidate as any);
    const to = parseFloat(toNetWtToValidate as any);
    if (
      !isNaN(from) &&
      !isNaN(to) &&
      from > to &&
      fromNetWtToValidate !== 0 &&
      toNetWtToValidate !== 0
    ) {
      setValue("fromNetWt", undefined);
    }
  }, [fromNetWtToValidate, toNetWtToValidate, setValue]);


  const getTextFromList = (value: string, list: any[]): string => {
    const item = list.find(item => item.value === value);
    return item ? item.text : '';
  };


  const renderImageUploadField = (isRequired = false) => (
    <div className="col-md-6 mb-2">
      <label className="text-muted small">
        Image
      </label>
      {!imagePreview ? (
        <input
          type="file"
          accept="image/jpeg, image/jpg, image/png"
          className="form-control form-control-sm w-50"
          onChange={handleFileChange}
          required={isRequired}
        />
      ) : (
        <div className="d-flex gap-2">
          <Button
            style={{ background: "none", border: "none", padding: 0, color: "#000" }}
            onClick={() => setShowImageModal(true)}
            title="View uploaded image"
          >
            <FontAwesomeIcon icon={faEye} className="me-1" />
          </Button>
          <Button
            style={{ background: "none", border: "none", padding: 0, color: "#000" }}
            onClick={handleRemoveImage}
            title="Remove image"
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </div>
      )}
      {errors.image && <small className="text-danger">Image is required</small>}
    </div>
  );

  const renderGoldFields = () => (
    <>
      <div className="col-md-3 mb-2">
        <label className=" text-muted small">Style No <span className="text-danger">*</span></label>
        <select
          className={`form-control form-control-sm form-select form-select-sm ${errors.styleNo ? "is-invalid" : ""}`}
          {...register("styleNo", {
            required: "Style no is required",
            onChange: (e) => {
              const value = e.target.value;
              setValue("styleNo", value);
              setValue("styleNoText", getTextFromList(value, styleList));
              setStyleNumber(getTextFromList(value, styleList))
            }
          })}
        >
          <option value="">--Select Style--</option>
          {styleList.map((item) => (
            <option key={item.value} value={item.value}>{item.text}</option>
          ))}
        </select>
        {errors.styleNo && <div className="invalid-feedback">{errors.styleNo.message}</div>}
      </div>

      <div className="col-md-3 mb-2">
        <label className="text-muted small">Category <span className="text-danger">*</span></label>
        <select
          className={`form-control form-control-sm form-select form-select-sm ${errors.category ? "is-invalid" : ""}`}
          {...register("category", {
            required: "Category is required",
            onChange: (e) => {
              const value = e.target.value;
              setValue("category", value);
              setValue("categoryText", getTextFromList(value, categoryList));
            }
          })}
        >
          <option value="">--Select Category--</option>
          {categoryList.map((item) => (
            <option key={item.value} value={item.value}>{item.text}</option>
          ))}
        </select>
        {errors.category && <div className="invalid-feedback">{errors.category.message}</div>}
      </div>

      <div className="col-md-3">
        <label className="text-muted small">Collection Name <span className="text-danger">*</span></label>
        <select
          className={`form-control form-control-sm form-select form-select-sm ${errors.collectionName ? "is-invalid" : ""}`}
          {...register("collectionName", {
            required: "Collection name is required",
            onChange: (e) => {
              const value = e.target.value;
              setValue("collectionName", value);
              setValue("collectionNameText", getTextFromList(value, collectionList));
            }
          })}
        >
          <option value="">--Select Collection--</option>
          {collectionList.map((item) => (
            <option key={item.value} value={item.value}>{item.text}</option>
          ))}
        </select>
        {errors.collectionName && <div className="invalid-feedback">{errors.collectionName.message}</div>}
      </div>

      <div className="col-md-3 mb-2">
        <label className="text-muted small">Metal KT <span className="text-danger">*</span></label>
        <select
          value={selectedKtId}
          className={`form-control form-control-sm form-select form-select-sm ${errors.kt ? "is-invalid" : ""}`}
          {...register("kt", {
            required: "Karat is required",
            onChange: (e) => {
              const value = e.target.value;
              setValue("kt", value);
              setSelectedKtId(value)
              setValue("ktText", getTextFromList(value, karatList));
              if (value) {
                GetOldGoldRateByKaratId(value);
              }
              setKarat(value)
            },
          })}
        >
          <option value="">--Select KT--</option>
          {karatList.map((kt) => (
            <option key={kt.value} value={kt.value}>{kt.text}</option>
          ))}
        </select>
        {errors.kt && <div className="invalid-feedback">{errors.kt.message}</div>}
      </div>

      <div className="col-md-3 mb-2">
        <label className="text-muted small">From Net Wt</label>
        <input
          type="number"
          step="0.001"
          max={10000}
          min={0}
          className={`form-control form-control-sm ${errors.fromNetWt ? "is-invalid" : ""
            }`}
          {...register("fromNetWt", {
            valueAsNumber: true,
            min: {
              value: 0,
              message: "Value must be positive",
            },
            max: {
              value: 10000,
              message: "Value must be less than or equal to 10,000",
            },

          })}
          onInput={(e) => {
            const input = e.currentTarget;
            if (input.value.includes('-')) {
              input.value = input.value.replace('-', '');
            }

            if (input.value.length > 5) {
              input.value = input.value.slice(0, 5); // trim extra digits
            }
          }}
        />
        {errors.fromNetWt && (
          <div className="invalid-feedback">
            {errors.fromNetWt.message}
          </div>
        )}
      </div>

      <div className="col-md-3 mb-2">
        <label className="text-muted small">To Net Wt</label>
        <input
          type="number"
          step="0.001"
          max={10000}
          min={0}
          className="form-control form-control-sm"
          {...register("toNetWt", {
            valueAsNumber: true,
            min: {
              value: 0,
              message: "Value must be positive",
            },
            max: {
              value: 10000,
              message: "Value must be less than or equal to 10,000",
            },

          })}
          onInput={(e) => {
            const input = e.currentTarget;
            if (input.value.includes('-')) {
              input.value = input.value.replace('-', '');
            }
            if (input.value.length > 5) {
              input.value = input.value.slice(0, 5); // trim extra digits
            }
          }}
        />
        {errors.toNetWt && (
          <div className="invalid-feedback">
            {errors.toNetWt.message}
          </div>
        )}
      </div>

      <div className="col-md-3 mb-2">
        <label className="text-muted small">Gold Rate</label>
        <input
          type="number"
          step="0.01"
          readOnly
          value={
            watch("goldRate") !== undefined && watch("goldRate") !== null
              ? Number(watch("goldRate")).toFixed(2)
              : ""
          }
          className="form-control form-control-sm"
          {...register("goldRate", { valueAsNumber: true })}
        />
      </div>

      <div className="col-md-3 mb-2">
        <label className="text-muted small">Estimate Amt</label>
        <input
          type="number"
          step="0.01"
          readOnly
          className="form-control form-control-sm"
          {...register("estimateAmt", { valueAsNumber: true })}
        />
      </div>
      <div className="col-md-3 mb-2">
        <label className="text-muted small">Size</label>
        <input
          type="number"
          step="0.001"
          max={10000}
          min={0}
          className="form-control form-control-sm"
          {...register("size", {
            valueAsNumber: true,
            min: {
              value: 0,
              message: "Value must be positive",
            },
            max: {
              value: 10000,
              message: "Value must be less than or equal to 10,000",
            },

          })}
          onInput={(e) => {
            const input = e.currentTarget;
            if (input.value.includes('-')) {
              input.value = input.value.replace('-', '');
            }
            if (input.value.length > 5) {
              input.value = input.value.slice(0, 5);
            }
          }}
        />
        {errors.size && (
          <div className="invalid-feedback">
            {errors.size.message}
          </div>
        )}
      </div>

      {/* Replace the old image upload code with this single line */}
      {renderImageUploadField()}
    </>
  );

  const selectedsrpmrp = watch("srpMrpText")

  const renderDiamondFields = () => {
    return (
      <>
        <div className="col-md-3 mb-2">
          <label className="text-muted small">Style No <span className="text-danger">*</span></label>
          <select
            className={`form-control form-control-sm form-select form-select-sm ${errors.styleNo ? "is-invalid" : ""}`}
            {...register("styleNo", {
              required: "Style no is required",
              onChange: (e) => {
                const value = e.target.value;
                setValue("styleNo", value);
                setValue("styleNoText", getTextFromList(value, styleList));
                setStyleNumber(getTextFromList(value, styleList))
              }
            })}
          >
            <option value="">--Select Style--</option>
            {styleList.map((item) => (
              <option key={item.value} value={item.value}>{item.text}</option>
            ))}
          </select>
          {errors.styleNo && <div className="invalid-feedback">{errors.styleNo.message}</div>}
        </div>

        <div className="col-md-3 mb-2">
          <label className="text-muted small">Category <span className="text-danger">*</span></label>
          <select
            className={`form-control form-control-sm form-select form-select-sm ${errors.category ? "is-invalid" : ""}`}
            {...register("category", {
              required: "Category is required",

              onChange: (e) => {
                const value = e.target.value;
                setValue("category", value);
                setValue("categoryText", getTextFromList(value, categoryList));
              }
            })}
          >
            <option value="">--Select Category--</option>
            {categoryList.map((item) => (
              <option key={item.value} value={item.value}>{item.text}</option>
            ))}
          </select>
          {errors.category && <div className="invalid-feedback">{errors.category.message}</div>}
        </div>

        <div className="col-md-3 mb-2">
          <label className="text-muted small">Collection Name <span className="text-danger">*</span></label>
          <select
            className={`form-control form-control-sm form-select form-select-sm ${errors.collectionName ? "is-invalid" : ""}`}
            {...register("collectionName", {
              required: "Collection name is required",
              onChange: (e) => {
                const value = e.target.value;
                setValue("collectionName", value);
                setValue("collectionNameText", getTextFromList(value, collectionList));
              }
            })}
          >
            <option value="">--Select Collection--</option>
            {collectionList.map((item) => (
              <option key={item.value} value={item.value}>{item.text}</option>
            ))}
          </select>
          {errors.collectionName && <div className="invalid-feedback">{errors.collectionName.message}</div>}
        </div>

        <div className="col-md-3 mb-2">
          <label className="text-muted small">Od KT <span className="text-danger">*</span></label>
          <select
            className={`form-control form-control-sm form-select form-select-sm ${errors.odKt ? "is-invalid" : ""}`}
            {...register("odKt", {
              required: "Karat is required",
              onChange: (e) => {
                const value = e.target.value;
                setValue("odKt", value);
                setValue("odKtText", getTextFromList(value, karatList));
                if (value) {
                  GetOldGoldRateByKaratId(value);
                }
                setKarat(value)
              },
            })}
          >
            <option value="">--Select KT--</option>
            {karatList?.map((kt) => (
              <option key={kt.value} value={kt.value}>{kt.text}</option>
            ))}
          </select>
          {errors.odKt && <div className="invalid-feedback">{errors.odKt.message}</div>}
        </div>

        <div className="col-md-3 mb-2">
          <label className="text-muted small">Color Code</label>
          <input
            type="text"
            maxLength={50}
            className="form-control form-control-sm"
            {...register("colorCode")}
          />
        </div>

        <div className="col-md-3 mb-2">
          <label className="text-muted small">KT</label>
          <input
            type="text"
            className="form-control form-control-sm"
            {...register("kt")}
          />
        </div>

        <div className="col-md-3 mb-2">
          <label className="text-muted small">Diamond Clarity</label>
          <select
            className="form-control form-control-sm form-select form-select-sm"
            {...register("diamondClarity", {
              onChange: (e) => {
                const value = e.target.value;
                setValue("diamondClarity", value);
                setValue("diamondClarityText", getTextFromList(value, dimondClarityList));
              }
            })}
          >
            <option value="">--Select Clarity--</option>
            {dimondClarityList.map((item) => (
              <option key={item.value} value={item.value}>{item.text}</option>
            ))}
          </select>
        </div>

        <div className="col-md-3 mb-2">
          <label className="text-muted small">Dia.Wt</label>
          <input
            type="number"
            step="0.001"
            max={10000}
            min={0}
            className={`form-control form-control-sm ${errors.diaWt ? "is-invalid" : ""
              }`}
            {...register("diaWt", {
              valueAsNumber: true,
              min: {
                value: 0,
                message: "Value must be positive",
              },

              max: {
                value: 10000,
                message: "Value must be less than or equal to 10,000",
              },
              onChange: (e) => {
                if (e.target.value.includes('-')) {
                  e.target.value = e.target.value.replace('-', '');
                }

                if (Number(e.target.value) <= 10000) {
                  clearErrors("diaWt");
                }
              },

            })}
            onInput={(e) => {
              const input = e.currentTarget;
              if (input.value.length > 5) {
                input.value = input.value.slice(0, 5); // trim extra digits
              }
            }}
          />
          {errors.diaWt && (
            <div className="invalid-feedback">{errors.diaWt.message}</div>
          )}
        </div>

        <div className="col-md-3 mb-2">
          <label className="text-muted small">Dia Qty</label>
          <input
            type="number"
            min={0}
            max={999}
            className="form-control form-control-sm"
            {...register("diaQty", {
              valueAsNumber: true,
              min: { value: 0, message: "Must be at least 0" },
              max: { value: 999, message: "Maximum 3 digits allowed (999)" },
            })}
          />
        </div>

        <div className="col-md-3 mb-2">
          <label className="text-muted small">Premium/Promo</label>
          <select className="form-control form-control-sm form-select form-select-sm" {...register("premiumPromo")}>
            <option value="">--Select--</option>
            <option value="Premium">Premium</option>
            <option value="Promo">Promo</option>
          </select>
        </div>

        <div className="col-md-3 mb-2">
          <label className="text-muted small">SRP/MRP</label>
          <select
            className="form-control form-control-sm form-select form-select-sm"
            {...register("srpMrp", {
              onChange: (e) => {
                const value = e.target.value;
                setValue("srpMrp", value);
                setValue("srpMrpText", getTextFromList(value, mrpTypeList));
              }
            })}
          >
            {mrpTypeList.map((item) => (
              <option key={item.value} value={item.value}>{item.text}</option>
            ))}
          </select>
        </div>

        {selectedsrpmrp == "MRP" ? (
          <>
            <div className="col-md-3 mb-2">
              <label className="text-muted small">MRP</label>
              <input
                type="text"
                inputMode="decimal"
                placeholder="0.00"
                className={`form-control form-control-sm ${errors.mrp ? "is-invalid" : ""}`}
                {...register("mrp", {
                  validate: (value) =>
                    !value || /^\d{1,9}(\.\d{0,2})?$/.test(String(value)) || "Up to 9 digits before decimal and 2 decimals allowed",
                  setValueAs: (value) => value && value?.trim()
                })}
                onKeyDown={(e) => {
                  if (e.ctrlKey || e.metaKey) return;
                  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                  if (!/[0-9.]/.test(e.key) && !allowedKeys.includes(e.key)) e.preventDefault();
                  if (e.key === "." && (e.currentTarget.value.includes(".") || e.currentTarget.value === "")) e.preventDefault();
                }}
                onInput={(e) => {
                  const val = e.currentTarget.value;
                  const match = val.match(/^\d{0,9}(\.\d{0,2})?/);
                  e.currentTarget.value = match ? match[0] : "";
                }}
              />
              {errors.mrp && <div className="invalid-feedback">{errors.mrp.message}</div>}
            </div>
          </>
        ) : (
          <>
            <div className="col-md-3 mb-2">
              <label className="text-muted small">Dia Amt</label>
              <input
                type="text"
                inputMode="decimal"
                placeholder="0.00"
                className={`form-control form-control-sm ${errors.diaAmt ? "is-invalid" : ""}`}
                {...register("diaAmt", {
                  validate: (value) =>
                    !value || /^\d{1,9}(\.\d{0,2})?$/.test(String(value)) || "Up to 9 digits before decimal and 2 decimals allowed"
                })}
                onKeyDown={(e) => {
                  if (e.ctrlKey || e.metaKey) return;
                  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                  if (!/[0-9.]/.test(e.key) && !allowedKeys.includes(e.key)) e.preventDefault();
                  if (e.key === "." && (e.currentTarget.value.includes(".") || e.currentTarget.value === "")) e.preventDefault();
                }}
                onInput={(e) => {
                  const val = e.currentTarget.value;
                  const match = val.match(/^\d{0,9}(\.\d{0,2})?/);
                  e.currentTarget.value = match ? match[0] : "";
                }}
              />
              {errors.diaAmt && <div className="invalid-feedback">{errors.diaAmt.message}</div>}
            </div>
            <div className="col-md-3 mb-2">
              <label className="text-muted small">Color Stone AMT</label>
              <input
                type="text"
                inputMode="decimal"
                placeholder="0.00"
                className={`form-control form-control-sm ${errors.colorStoneAmt ? "is-invalid" : ""}`}
                defaultValue={0}
                {...register("colorStoneAmt", {
                  validate: (value) =>
                    !value || /^\d{1,9}(\.\d{0,2})?$/.test(String(value)) || "Up to 9 digits before decimal and 2 decimals allowed"
                })}
                onKeyDown={(e) => {
                  if (e.ctrlKey || e.metaKey) return;
                  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                  if (!/[0-9.]/.test(e.key) && !allowedKeys.includes(e.key)) e.preventDefault();
                  if (e.key === "." && (e.currentTarget.value.includes(".") || e.currentTarget.value === "")) e.preventDefault();
                }}
                onInput={(e) => {
                  const val = e.currentTarget.value;
                  const match = val.match(/^\d{0,9}(\.\d{0,2})?/);
                  e.currentTarget.value = match ? match[0] : "";
                }}
              />
              {errors.colorStoneAmt && <div className="invalid-feedback">{errors.colorStoneAmt.message}</div>}
            </div>

            <div className="col-md-3 mb-2">
              <label className="text-muted small">Gold Rate</label>
              <input
                type="number"
                step="0.01"
                value={
                  watch("goldRate") !== undefined && watch("goldRate") !== null
                    ? Number(watch("goldRate")).toFixed(2)
                    : ""
                }
                className="form-control form-control-sm"
                {...register("goldRate", { valueAsNumber: true })}
                disabled
              />
            </div>
            <div className="col-md-3 mb-2">
              <label className="text-muted small">From Net Wt</label>
              <input
                type="number"
                step="0.001"
                max={10000}
                min={0}
                className={`form-control form-control-sm ${errors.fromNetWt ? "is-invalid" : ""
                  }`}
                {...register("fromNetWt", {
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: "Value must be positive",
                  },
                  max: {
                    value: 10000,
                    message: "Value must be less than or equal to 10,000",
                  },
                  onChange: (e) => {
                    if (e.target.value.includes('-')) {
                      e.target.value = e.target.value.replace('-', '');
                    }
                    if (Number(e.target.value) <= 10000) {
                      clearErrors("fromNetWt");
                    }
                  },

                })}
                onInput={(e) => {
                  const input = e.currentTarget;
                  if (input.value.length > 5) {
                    input.value = input.value.slice(0, 5);
                  }
                }}
              />
              {errors.fromNetWt && (
                <div className="invalid-feedback">
                  {errors.fromNetWt.message}
                </div>
              )}
            </div>
            <div className="col-md-3 mb-2">
              <label className="text-muted small">To Net Wt</label>
              <input
                type="number"
                step="0.001"
                max={10000}
                min={0}
                className="form-control form-control-sm"
                {...register("toNetWt", {
                  valueAsNumber: true,
                  min: {
                    value: 0,
                    message: "Value must be positive",
                  },
                  max: {
                    value: 10000,
                    message: "Value must be less than or equal to 10,000",
                  },
                  onChange: (e) => {
                    if (e.target.value.includes('-')) {
                      e.target.value = e.target.value.replace('-', '');
                    }
                    if (Number(e.target.value) <= 10000) {
                      clearErrors("toNetWt");
                    }
                  },

                })}
                onInput={(e) => {
                  const input = e.currentTarget;
                  if (input.value.length > 5) {
                    input.value = input.value.slice(0, 5); // trim extra digits
                  }
                }}
              />
              {errors.toNetWt && (
                <div className="invalid-feedback">
                  {errors.toNetWt.message}
                </div>
              )}
            </div>
            <div className="col-md-3 mb-2">
              <label className="text-muted small">Sub MRP</label>
              <input
                type="number"
                step="0.01"
                disabled
                className="form-control form-control-sm"
                {...register("subMrp", { valueAsNumber: true })}
              />
            </div>
          </>
        )}

        <div className="col-md-3 mb-2">
          <label className="text-muted small">Size</label>
          <input
            type="number"
            step="0.001"
            max={10000}
            min={0}
            className="form-control form-control-sm"
            {...register("size", {
              valueAsNumber: true,
              min: {
                value: 0,
                message: "Value must be positive",
              },
              max: {
                value: 10000,
                message: "Value must be less than or equal to 10,000",
              },

            })}
            onInput={(e) => {
              const input = e.currentTarget;
              if (input.value.includes('-')) {
                input.value = input.value.replace('-', '');
              }
              if (input.value.length > 5) {
                input.value = input.value.slice(0, 5);
              }
            }}
          />
          {errors.size && (
            <div className="invalid-feedback">
              {errors.size.message}
            </div>
          )}
        </div>

        {renderImageUploadField()}

        <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered size="lg">
          <Modal.Header closeButton className=" text-white border-0">
            <Modal.Title className="fs-5">Image Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-light d-flex flex-column align-items-center justify-content-center p-4">
            <div
              className="border rounded shadow-lg overflow-hidden"
              style={{ maxHeight: "500px", maxWidth: "100%", borderColor: "#dee2e6" }}
            >
              <img
                src={imagePreview ?? ""}
                alt="Preview"
                className="img-fluid"
                style={{ objectFit: "contain", height: "100%", width: "100%" }}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="bg-white border-0 d-flex justify-content-between">
            <div className="text-muted small">Want to upload another? Just select again.</div>
            <Button variant="btn add-btn" onClick={() => setShowImageModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };

  const [materialTypes, setMaterialTypes] = useState<{ value: string; text: string }[]>([]);

  useEffect(() => {
    if (show)
      MaterialTypeListData()
  }, [show])

  const MaterialTypeListData = async () => {
    try {
      const response = await GetMaterialTypeList()
      setMaterialTypes(response)
    } catch (error: any) {
      console.log(error.message)
      notistack.notifyFromApi(error.message)
      setMaterialTypes([])
    }
  }

  const ImagePreviewModal = ({ show, onHide, imageSrc }: { show: boolean, onHide: () => void, imageSrc: string | null }) => (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton className="text-white border-0">
        <Modal.Title className="fs-5">Image Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-light d-flex flex-column align-items-center justify-content-center p-4">
        <div
          className="border rounded shadow-lg overflow-hidden"
          style={{ maxHeight: "500px", maxWidth: "100%", borderColor: "#dee2e6" }}
        >
          <img
            src={imageSrc ?? ""}
            alt="Preview"
            className="img-fluid"
            style={{ objectFit: "contain", height: "100%", width: "100%" }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-white border-0 d-flex justify-content-between">
        <div className="text-muted small">Want to upload another? Just select again.</div>
        <Button variant="btn add-btn" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );


  return (
    <>
      <Modal show={show} onHide={handleModalHide} size="lg" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? "Edit Product" : "Add Product"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-3 mb-2">
                <label className="text-muted small">Material Type <span className="text-danger">*</span></label>
                <select
                  className={`form-control form-control-sm form-select form-select-sm ${errors.materialType ? "is-invalid" : ""}`}
                  value={selectedMaterialType}
                  {...register("materialType", { required: "Material type is required" })}
                  onChange={handleMaterialTypeChange}
                >
                  <option value="">--Select Material Type--</option>
                  {materialTypes?.length > 0 &&
                    materialTypes
                      .filter((m) => ["gold", "diamond"].includes(m.text.toLowerCase()))
                      .map((m) => (
                        <option key={m.value} value={m.text}>
                          {m.text}
                        </option>
                      ))}
                </select>
                {errors.materialType && (
                  <div className="invalid-feedback">{errors.materialType.message}</div>
                )}
              </div>
            </div>

            {selectedMaterialType === "Gold" && (
              <div className="row">
                {renderGoldFields()}
              </div>
            )}

            {selectedMaterialType === "Diamond" && (
              <div className="row">
                {renderDiamondFields()}
              </div>
            )}

            <div className="d-flex justify-content-end mt-3">
              <Button onClick={handleModalHide} className="me-2 btn add-btn">
                Cancel
              </Button>
              <Button type="submit" className="btn submit-btn" disabled={loading}>
                {loading ? <Loader /> : isEditMode ? "Update" : "Save"}
              </Button>
            </div>
          </form>
        </Modal.Body>
        <ImagePreviewModal
          show={showImageModal}
          onHide={() => setShowImageModal(false)}
          imageSrc={imagePreview}
        />
      </Modal>


      <RedirectionModal isOpen={isRedirectOpen} onClose={() => setIsRedirectOpen(false)} data={productAvailbleData} />
    </>

  );
};

export default CustomOrderModal;